import { unpack } from '../../utils/index.js';
import lch2rgb from './lch2rgb.js';
const hcl2rgb = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  const hcl = unpack(args, 'hcl').reverse();
  return lch2rgb(...hcl);
};
export default hcl2rgb;